// extracted by mini-css-extract-plugin
export default {"error":"Error_error__P1d37","error404":"Error_error404__kIBVA"};